import * as React from "react";
import LabelledDataForm from "../label/LabelledDataForm";
import { HouseholdInfo } from "../patient-portal/HouseholdInfo";
import { getI18NKey } from "../commons/model/patient/PatientRelationship";
import { formatBirthDateAndAge } from "../commons/utils/text-rendering";

export default function HouseholdDetails({ householdInfo }: { householdInfo: HouseholdInfo }) {
  return (
    <>
      {householdInfo.members &&
        householdInfo.members.map((member) => (
          <div key={`${member.firstName}-${member.lastName}`}>
            <h3>{i18n[getI18NKey(member.relationship)]}</h3>
            <LabelledDataForm
              data={[
                {
                  label: i18n["Global.FirstName"],
                  value: member.firstName,
                },
                {
                  label: i18n["Global.LastName"],
                  value: member.lastName,
                },
                {
                  label: i18n["Global.Birthdate"],
                  value: formatBirthDateAndAge(member.birthdate),
                },
              ]}
            />
          </div>
        ))}
    </>
  );
}
